import type {UpdateServiceFormPayload} from "./update-service.schema";

import {updateService} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../service-keys";

export function updateServiceMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: serviceMutationKeys.updateService,
    mutationFn: (payload: UpdateServiceFormPayload) => updateService(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceKeys.detail(id)}),
        client.invalidateQueries({queryKey: serviceKeys.lists()}),
      ]);
    },
  });
}
